var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'chat-user-avatar',
    // `chat-user-avatar--status-${status}`,
    { 'chat-user-avatar--without-img': !_vm.avatarSrc } ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.avatarSrc)?_c('img',{attrs:{"src":_vm.avatarSrc,"alt":"user avatar"}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }